import { PreviewLedgerDataset } from "../previewTypes";

export const GENERAL_LEDGER_DATASET: PreviewLedgerDataset = {
    shape: "ledger",
    dateHeader: "Date",
    descriptionHeader: "Description",
    debitHeader: "Debit",
    creditHeader: "Credit",
    balanceHeader: "Balance",
    percentHeader: "% of total",
    percentBase: 1350000,
    rows: [
        { id: "checking-account", label: "1000 · Checking", kind: "account" },
        {
            id: "checking-open",
            kind: "transaction",
            date: "Jan 1",
            label: "Beginning Balance",
            balance: 120000,
        },
        {
            id: "checking-payroll",
            kind: "transaction",
            date: "Jan 22",
            label: "Payroll run — January and February",
            credit: 314000,
            balance: -194000,
        },
        {
            id: "checking-acme",
            kind: "transaction",
            date: "Feb 12",
            label: "Client payment — Acme Corp",
            debit: 1350000,
            balance: 1156000,
        },
        {
            id: "checking-globex",
            kind: "transaction",
            date: "Apr 21",
            label: "Client payment — Globex",
            debit: 24198.42,
            balance: 1180198.42,
        },
        {
            id: "checking-total",
            kind: "total",
            label: "Ending Balance",
            balance: 1180198.42,
            hasTopBorder: true,
        },
        { id: "checking-spacer", kind: "spacer" },
        { id: "savings-account", label: "1100 · Savings", kind: "account" },
        {
            id: "savings-open",
            kind: "transaction",
            date: "Jan 1",
            label: "Beginning Balance",
            balance: 450000,
        },
        {
            id: "savings-contribution",
            kind: "transaction",
            date: "Mar 3",
            label: "Owner contribution",
            debit: 50000,
            balance: 500000,
        },
        {
            id: "savings-total",
            kind: "total",
            label: "Ending Balance",
            balance: 500000,
            hasTopBorder: true,
        },
        { id: "savings-spacer", kind: "spacer" },
        {
            id: "receivable-account",
            label: "1200 · Accounts Receivable",
            kind: "account",
        },
        {
            id: "receivable-open",
            kind: "transaction",
            date: "Jan 1",
            label: "Beginning Balance",
            balance: 452450,
        },
        {
            id: "receivable-invoice",
            kind: "transaction",
            date: "Jan 30",
            label: "Invoice — Acme Corp",
            debit: 1300000,
            balance: 1752450,
        },
        {
            id: "receivable-acme",
            kind: "transaction",
            date: "Feb 12",
            label: "Client payment — Acme Corp",
            credit: 1350000,
            balance: 402450,
        },
        {
            id: "receivable-total",
            kind: "total",
            label: "Ending Balance",
            balance: 402450,
            hasTopBorder: true,
        },
        { id: "receivable-spacer", kind: "spacer" },
        {
            id: "prepaid-account",
            label: "1400 · Prepaid Expenses",
            kind: "account",
            isNeverUsed: true,
        },
        {
            id: "prepaid-open",
            kind: "transaction",
            date: "Jan 1",
            label: "Beginning Balance",
            balance: 0,
            isNeverUsed: true,
        },
        {
            id: "prepaid-total",
            kind: "total",
            label: "Ending Balance",
            balance: 0,
            hasTopBorder: true,
            isNeverUsed: true,
        },
    ],
};
